import type { Component } from 'solid-js'
import { For, Show } from 'solid-js'
import Button from '~/components/Button'
import ButtonGroup from '~/components/ButtonGroup'
import Card from '~/components/Card'
import Chip from '~/components/Chip'
import Icon from '~/components/Icon'
import { P } from '~/utils/permissions'
import type { TabBancosProps } from './types'

const TabBancos: Component<TabBancosProps> = props => {
  return (
    <>
      <div class="flex justify-end mb-4">
        <Show when={props.can(P.customers.update)}>
          <Button size="sm" variant="soft" color="primary" onClick={() => props.openBankModal()} prependIcon="material-symbols-light:add">
            Nueva cuenta
          </Button>
        </Show>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <For each={props.data.banks ?? []} fallback={<p class="text-foreground-subtle col-span-full">Sin cuentas bancarias.</p>}>
          {bank => (
            <Card>
              <Card.Body>
                {/* Las acciones van en la cabecera: al pie obligaban a reservar
                    una franja bajo los datos y la tarjeta quedaba con un hueco. */}
                <div class="flex items-center justify-between gap-2 mb-3">
                  <div class="flex items-center gap-2 min-w-0">
                    <Icon icon="material-symbols-light:account-balance-outline" size={22} class="text-primary shrink-0" />
                    <p class="font-semibold text-foreground truncate">{bank.banco}</p>
                  </div>
                  <div class="flex shrink-0 items-center gap-1">
                    <Show when={bank.principal}>
                      <Chip size="xs" variant="soft" color="success">
                        Principal
                      </Chip>
                    </Show>
                    <ButtonGroup size="xs" variant="text">
                      <Show when={props.can(P.customers.update)}>
                        <Button color="warning" onClick={() => props.openBankModal(bank)} icon="material-symbols-light:edit-outline" tooltip="Editar" aria-label="Editar cuenta" />
                      </Show>
                      <Show when={props.can(P.customers.delete)}>
                        <Button color="danger" onClick={() => props.removeBank(bank.id)} icon="material-symbols-light:delete-outline" tooltip="Eliminar" aria-label="Eliminar cuenta" />
                      </Show>
                    </ButtonGroup>
                  </div>
                </div>
                <div class="space-y-1.5">
                  <div class="flex items-center gap-1.5 text-sm">
                    <Icon icon="material-symbols-light:credit-card-outline" size={16} class="text-foreground-subtle shrink-0" />
                    <span class="font-mono text-foreground">{bank.numeroCuenta || '—'}</span>
                  </div>
                  <div class="flex items-center gap-1.5 text-sm text-foreground-subtle">
                    <Icon icon="material-symbols-light:label-outline" size={16} class="shrink-0" />
                    <span>{bank.tipoCuenta || '—'}</span>
                  </div>
                  <div class="flex items-center gap-1.5 text-sm text-foreground-subtle">
                    <Icon icon="material-symbols-light:person-outline" size={16} class="shrink-0" />
                    <span class="truncate">{bank.titular || '—'}</span>
                  </div>
                  <Show when={bank.documento}>
                    <div class="flex items-center gap-1.5 text-xs text-foreground-subtle">
                      <Icon icon="material-symbols-light:badge-outline" size={14} class="shrink-0" />
                      <span class="truncate">{bank.documento}</span>
                    </div>
                  </Show>
                </div>
              </Card.Body>
            </Card>
          )}
        </For>
      </div>
    </>
  )
}

export default TabBancos
